import React, { useState } from "react";
import { IoEyeSharp, IoEyeOff } from "react-icons/io5";

const AuthInput = ({ label, id, type = "text", value, onChange, icon, placeholder, autoComplete, helper }) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  return (
    <div className="mb-3">
      <label htmlFor={id} className="a-font login-label">
        {label}
      </label>
      <div className="d-flex login-input gap-2 align-items-center px-2">
        {icon}
        <input
          type={isPassword ? (showPassword ? "text" : "password") : type}
          name={id}
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          className="a-font"
        />
        {isPassword &&
          (showPassword ? (
            <IoEyeSharp
              size={20}
              style={{ cursor: "pointer", flexShrink: 0 }}
              onClick={() => setShowPassword(false)}
            />
          ) : (
            <IoEyeOff
              size={20}
              style={{ cursor: "pointer", flexShrink: 0 }}
              onClick={() => setShowPassword(true)}
            />
          ))}
      </div>
      {helper && <div className="a-font auth-helper">{helper}</div>}
    </div>
  );
};

export default AuthInput;
